export enum EParticipantStatus {
  STATUS_UNKNOWN = 'unknown',
  STATUS_ATTENDANCE_CONFIRMED = 'attendance-confirmed',
  STATUS_ATTENDANCE_REJECTED = 'attendance-rejected'
}
